var TSCOOKIE = {

	cookie : {

		necessary : true,
		preferences : false,
		statistics : false,
		marketing : false,

	},
	responded : false,
	accepted : false,
	declined : false,

};

/*
JS hooks demo

document.addEventListener('tscookiesLoaded', function() {

	alert( 'load' );

});

document.addEventListener('tscookiesSetConsent', function() {

	alert( 'consent' );

});
*/

var dataLayer = window.dataLayer = window.dataLayer || null;

;(function($, undefined) {

	$.fn.outerHTML = function(s) {
		return s
			? this.before(s).remove()
			: jQuery("<p>").append(this.eq(0).clone()).html();
	};

	var TSCOOKIES = {
		
		pluginURL:		tsCookiesConsent.pluginsUrl,
		templateType:	tsCookiesConsent.templateType,
		version: 		tsCookiesConsent.version,
		sessionHash:	'',

		init: {
			
			init: function() {
				
				TSCOOKIES.sessionHash = TSCOOKIES.init.createHash();
				
				TSCOOKIES.cookie.checkCookieVersion();

				TSCOOKIES.html.loadTemplate();

			},
			
			initAfterRender: function() {

				var cookie = TSCOOKIES.cookie.get();

				if ( !cookie ) {

					TSCOOKIES.html.showBanner();

				} else {
					
					TSCOOKIES.html.hideBanner();

					TSCOOKIES.cookie.createObject(

						cookie.stamp,
						cookie.necessary,
						cookie.preferences,
						cookie.statistics,
						cookie.marketing,
						cookie.version,

					);

					TSCOOKIES.object.updateObject();

					TSCOOKIES.gtm.init();

				}

				TSCOOKIES.sources.init();
  
				TSCOOKIES.init.toggleBanner();
				
				TSCOOKIES.hooks.triggerOnLoad();

			},

			toggleBanner: function() {

				$( document ).on( 'click', '.tsCookieSettings', function( e ) {

					e.preventDefault();

					TSCOOKIES.html.showBanner();

				} );
			},

			createHash: function() {

				var hash = "";

				var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
			  
				for (var i = 0; i < 128; i++) {
				 
					hash += possible.charAt( Math.floor( Math.random() * possible.length ) );

				}

				return hash;
			
			}
			
		},

		cookie: {

			name: 'CookieConsent',
			necessary: true,
			preferences: false,
			statistics: false,
			marketing: false,
			
			set: function( hash, necessary, preferences, statistics, marketing, version ) {

				var CookieConsentObject = TSCOOKIES.cookie.createObject(
					
					hash,
					necessary,
					preferences,
					statistics,
					marketing,
					version
				
				);

				var expireDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1) );
				
				document.cookie = TSCOOKIES.cookie.name + "=" + JSON.stringify( CookieConsentObject ) + "; path=/; expires=" + expireDate;

				TSCOOKIES.cookie.log( CookieConsentObject );

				TSCOOKIES.object.updateObject();

				TSCOOKIES.hooks.triggerOnConsent();

			},

			get: function() {

				var b = document.cookie.match('(^|;)\\s*' + TSCOOKIES.cookie.name + '\\s*=\\s*([^;]+)');

				return b ? JSON.parse( b.pop() ) : '';

			},

			delete: function() {

				document.cookie = TSCOOKIES.cookie.name + "=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;";

			},

			log: function( cookieObject ) {
				
				$.post(tsCookiesConsent.adminUrl, {
					
					action: 'log_consent',
					object: cookieObject,
					url: window.location.href
					
				}, function( data ) {
					
					//console.log( data );
					
				});

			},

			createObject: function( hash, necessary, preferences, statistics, marketing, version ) {

				var cookieObject = {

					stamp		:	hash,
					necessary	:	necessary,
					preferences	:	preferences,
					statistics	:	statistics,
					marketing	:	marketing,
					version		:	version

				};

				TSCOOKIES.cookie.necessary = necessary;
				TSCOOKIES.cookie.preferences = preferences;
				TSCOOKIES.cookie.statistics = statistics;
				TSCOOKIES.cookie.marketing = marketing;
				TSCOOKIES.cookie.version = version;

				return cookieObject;

			},

			checkCookieVersion: function() {

				var cookie = TSCOOKIES.cookie.get();

				if ( cookie != null ) {

					if ( cookie.version === undefined || cookie.version < TSCOOKIES.version ) {

						TSCOOKIES.cookie.delete();

					}

				}

			}

		},

		html: {

			html: '',

			loadTemplate: function () {

				var templateHtml = '';

				var templateHtml = TSCOOKIES.templateType == 'advanced' ? tsCookiesConsent.bar_template_advanced : tsCookiesConsent.bar_template_basic;
				
				if ( tsCookiesConsent.template_load == null || tsCookiesConsent.template_load.indexOf( 'default' ) === 0 || templateHtml == '' || templateHtml == null ) {
					
					var templatePath = TSCOOKIES.templateType == 'advanced' ? 'templates/banner-advanced.mst' : 'templates/banner-basic.mst';
					
					$.get( TSCOOKIES.pluginURL + templatePath, function ( data ) {

						templateHtml = data;
						
						TSCOOKIES.html.renderTemplate( templateHtml );

					});

				} else {

					TSCOOKIES.html.renderTemplate( templateHtml );

				}

			},

			renderTemplate: function( templateHtml ) {
				
				if ( tsCookiesConsent.bar_policies_necessary.length > 0 ) {

					tsCookiesConsent.bar_policies_necessary = {

						'policies'	:	tsCookiesConsent.bar_policies_necessary

					};

				}

				if ( tsCookiesConsent.bar_policies_preferences.length > 0 ) {

					tsCookiesConsent.bar_policies_preferences = {

						'policies'	:	tsCookiesConsent.bar_policies_preferences

					};

				}

				if ( tsCookiesConsent.bar_policies_statistics.length > 0 ) {

					tsCookiesConsent.bar_policies_statistics = {

						'policies'	:	tsCookiesConsent.bar_policies_statistics

					};

				}

				if ( tsCookiesConsent.bar_policies_marketing.length > 0 ) {

					tsCookiesConsent.bar_policies_marketing = {

						'policies'	:	tsCookiesConsent.bar_policies_marketing

					};

				}

				var rendered = Mustache.render( templateHtml, {

					bannerPosition: tsCookiesConsent.display_position[0],

					bannerText: tsCookiesConsent.bar_text,

					btnAcceptLabel: tsCookiesConsent.bar_button_accept_label,
					btnDeclineLabel: tsCookiesConsent.bar_button_decline_label,
					btnEditLabel: tsCookiesConsent.bar_button_edit_label,
					btnDetailsLabel: tsCookiesConsent.bar_button_details_label,
					btnCancelLabel: tsCookiesConsent.bar_button_cancel_label,
					btnSaveLabel: tsCookiesConsent.bar_button_save_label,
					
					checkboxLabelNecessary: tsCookiesConsent.bar_checkbox_necessary_label,
					checkboxLabelPreferences: tsCookiesConsent.bar_checkbox_preferences_label,
					checkboxLabelStatistics: tsCookiesConsent.bar_checkbox_statistics_label,
					checkboxLabelMarketing: tsCookiesConsent.bar_checkbox_marketing_label,

					checkboxDescriptionNecessary: tsCookiesConsent.bar_description_necessary,
					checkboxDescriptionPreferences: tsCookiesConsent.bar_description_preferences,
					checkboxDescriptionStatistics: tsCookiesConsent.bar_description_statistics,
					checkboxDescriptionMarketing: tsCookiesConsent.bar_description_marketing,
					
					policiesNecessary: tsCookiesConsent.bar_policies_necessary,
					policiesPreferences: tsCookiesConsent.bar_policies_preferences,
					policiesStatistics: tsCookiesConsent.bar_policies_statistics,
					policiesMarketing: tsCookiesConsent.bar_policies_marketing,

				});

				TSCOOKIES.html.html = $('<div/>').html( rendered ).contents();

				$('body').append( TSCOOKIES.html.html );

				TSCOOKIES.html.html
					.find( '.tsCookieDecline' )
					.on( 'click', TSCOOKIES.html.clickDecline );

				TSCOOKIES.html.html
					.find( '.tsCookieAccept' )
					.on( 'click', TSCOOKIES.html.clickAccept );


				TSCOOKIES.html.banner = TSCOOKIES.html.html.find( '.tsCookieBanner' );

				TSCOOKIES.init.initAfterRender();

				if ( TSCOOKIES.templateType == 'advanced' ) {

					TSCOOKIES.html.html
						.find('.tsCookieEdit')
						.on('click', TSCOOKIES.html.clickEdit );

					TSCOOKIES.html.html
						.find('.tsCookieCancel')
						.on('click', TSCOOKIES.html.clickCancel );

					TSCOOKIES.html.html
						.find('.tsCookieSave')
						.on('click', TSCOOKIES.html.clickSave );

					TSCOOKIES.html.html
						.find('.tsCookieDetail')
						.on('click', TSCOOKIES.html.clickDetail );

					TSCOOKIES.html.modal = TSCOOKIES.html.html.find( '.tsCookieModal' );

					TSCOOKIES.html.initModal();

				}
				
			},
			
			showBanner: function() {

				TSCOOKIES.html.banner.show();

			},

			hideBanner: function() {

				TSCOOKIES.html.banner.hide();

			},

			initModal: function() {

				TSCOOKIES.html.html.find( '#tsCookieNecessary' ).prop ('checked', TSCOOKIES.cookie.necessary );
				TSCOOKIES.html.html.find( '#tsCookiePreferences' ).prop ('checked', TSCOOKIES.cookie.preferences );
				TSCOOKIES.html.html.find( '#tsCookieStatistics' ).prop( 'checked', TSCOOKIES.cookie.statistics );
				TSCOOKIES.html.html.find( '#tsCookieMarketing' ).prop( 'checked', TSCOOKIES.cookie.marketing );

				TSCOOKIES.html.html.find( '#tsCookieNecessary' ).prop( 'disabled', true );

				/* var policiesNecessary = tsCookiesConsent.bar_policies_necessary;
				var policiesPreferences = tsCookiesConsent.bar_policies_preferences;
				var policiesStatistics = tsCookiesConsent.bar_policies_statistics;
				var policiesMarketing = tsCookiesConsent.bar_policies_marketing;
				
				if ( Array.isArray( policiesNecessary ) && !policiesNecessary[0]['title'] ) {

					TSCOOKIES.html.html.find( '.tsCookieDetailsNecessary' ).remove();

				}

				if ( Array.isArray( policiesPreferences ) && !policiesPreferences[0]['title'] ) {

					TSCOOKIES.html.html.find( '.tsCookieDetailsPreferences' ).remove();

				}

				if ( Array.isArray( policiesStatistics ) && !policiesStatistics[0]['title'] ) {

					TSCOOKIES.html.html.find( '.tsCookieDetailsStatistics' ).remove();

				}

				if ( Array.isArray( policiesMarketing ) && !policiesMarketing[0]['title'] ) {

					TSCOOKIES.html.html.find( '.tsCookieDetailsMarketing' ).remove();

				} */

			},


			showModal: function () {

				TSCOOKIES.html.html.addClass( 'ts-cookie-consent--modal-open' );

			},

			hideModal: function () {

				TSCOOKIES.html.html.removeClass( 'ts-cookie-consent--modal-open' );

			},

			toggleDetails: function( e ) {				

				var container = $( e.target ).parents( '.ts-cookie-option' );

				if ( $( container ).hasClass( 'ts-cookie-option--details-open' ) ) {
					
					$( container ).removeClass( 'ts-cookie-option--details-open' );
			
				} else {

					$( '.ts-cookie-option' ).removeClass( 'ts-cookie-option--details-open' );

					$( container ).addClass( 'ts-cookie-option--details-open' );

				}

			},

			clickSave: function( e ) {

				e.preventDefault();

				var necessary   = TSCOOKIES.html.html.find( '#tsCookieNecessary' ).prop( 'checked' ) ? true : false;
				var preferences = TSCOOKIES.html.html.find( '#tsCookiePreferences' ).prop( 'checked' ) ? true : false;
				var statistics  = TSCOOKIES.html.html.find( '#tsCookieStatistics' ).prop( 'checked' ) ? true : false;
				var marketing   = TSCOOKIES.html.html.find( '#tsCookieMarketing' ).prop( 'checked' ) ? true : false;

				var version		= TSCOOKIES.version;
				
				TSCOOKIES.cookie.set(

					TSCOOKIES.sessionHash,
					necessary,
					preferences,
					statistics,
					marketing,
					version,
					
				);

				TSCOOKIES.html.reload();

			},

			clickAccept: function( e ) {

				e.preventDefault();

				var version		= TSCOOKIES.version;

				TSCOOKIES.cookie.set(

					TSCOOKIES.sessionHash,
					true,
					true,
					true,
					true,
					version

				);

				TSCOOKIES.sources.afterConsent();
				TSCOOKIES.html.reload();

			},

			clickDecline: function( e ) {

				e.preventDefault();

				var version		= TSCOOKIES.version;

				TSCOOKIES.cookie.set(

					TSCOOKIES.sessionHash,
					true,
					false,
					false,
					false,
					version
					
				);

				TSCOOKIES.html.hideBanner();
				TSCOOKIES.sources.afterConsent();

			},

			clickEdit: function (e) {

				e.preventDefault();

				TSCOOKIES.html.hideBanner();

				TSCOOKIES.html.showModal();
			},


			clickCancel: function (e) {

				e.preventDefault();

				TSCOOKIES.html.showBanner();

				TSCOOKIES.html.hideModal();
			},

			clickDetail: function (e) {

				e.preventDefault();

				TSCOOKIES.html.toggleDetails( e );
				
			},

			reload: function() {

				if ( tsCookiesConsent.reload == 'hard' ) {

					location.reload();

				} else {

					TSCOOKIES.html.hideBanner();
					TSCOOKIES.html.hideModal();
  
					TSCOOKIES.gtm.init();

				}

			}

		},

		object: {

			updateObject : function() {
				
				/*
				console.log( 'necessary: ' + TSCOOKIE.cookie.necessary);
				console.log( 'preferences: ' + TSCOOKIE.cookie.preferences);
				console.log( 'statistics: ' + TSCOOKIE.cookie.statistics);
				console.log( 'marketing: ' + TSCOOKIE.cookie.marketing);
				
				console.log( 'responded: ' + TSCOOKIE.responded);
				console.log( 'accepted: ' + TSCOOKIE.accepted);
				console.log( 'declined: ' + TSCOOKIE.declined);
				console.log( '----------' );
				*/

				var cookie = TSCOOKIES.cookie.get();

				var cookieAccepted = false;
				var cookieDeclined = false;

				if ( cookie != null ) {

					cookieAccepted = true;
					
					TSCOOKIE.responded = true;
					
				}
				
				if ( cookie.necessary != null && typeof( cookie.necessary ) === 'boolean' ) {
					
					TSCOOKIE.cookie.necessary = cookie.necessary;

					if ( cookie.necessary === false ) {

						cookieAccepted = false;
						cookieDeclined = true;

					}

				}

				if ( cookie.preferences != null && typeof( cookie.preferences ) === 'boolean' ) {
					
					TSCOOKIE.cookie.preferences = cookie.preferences;

					if ( cookie.preferences === false ) {

						cookieAccepted = false;
						cookieDeclined = true;

					}

				}

				if ( cookie.statistics != null && typeof( cookie.statistics ) === 'boolean' ) {
					
					TSCOOKIE.cookie.statistics = cookie.statistics;

					if ( cookie.statistics === false ) {

						cookieAccepted = false;
						cookieDeclined = true;

					}

				}

				if ( cookie.marketing != null && typeof( cookie.marketing ) === 'boolean' ) {
					
					TSCOOKIE.cookie.marketing = cookie.marketing;

					if ( cookie.marketing === false ) {

						cookieAccepted = false;
						cookieDeclined = true;

					}

				}

				TSCOOKIE.accepted = cookieAccepted;
				TSCOOKIE.declined = cookieDeclined;

				/* 
				console.log( 'necessary: ' + TSCOOKIE.cookie.necessary);
				console.log( 'preferences: ' + TSCOOKIE.cookie.preferences);
				console.log( 'statistics: ' + TSCOOKIE.cookie.statistics);
				console.log( 'marketing: ' + TSCOOKIE.cookie.marketing);
				
				console.log( 'responded: ' + TSCOOKIE.responded);
				console.log( 'accepted: ' + TSCOOKIE.accepted);
				console.log( 'declined: ' + TSCOOKIE.declined);
				*/
				
			}

		},

		gtm: {
			
			interval: '',

			timing: 100,			// checking every 0.1 seconds
			timeOut: 3000,			// max running 3 seconds
			timeRunning: 0,			// counter

			init: function() {
				
				if ( tsCookiesConsent.gtm == null || tsCookiesConsent.gtm != 'true' ) {

					TSCOOKIES.gtm.timeRunning = 0;

					TSCOOKIES.gtm.interval = setInterval( TSCOOKIES.gtm.checkForDataLayer, TSCOOKIES.gtm.timing );
					
				}

			},

			checkForDataLayer: function() {
				
				TSCOOKIES.gtm.timeRunning = TSCOOKIES.gtm.timeRunning + TSCOOKIES.gtm.timing;

				if ( dataLayer != null  ) {
					
					TSCOOKIES.gtm.pushToDataLayer();

				}

				if ( dataLayer != null || TSCOOKIES.gtm.timeRunning >= TSCOOKIES.gtm.timeOut ) {

					clearInterval( TSCOOKIES.gtm.interval );

				}

			},

			pushToDataLayer: function() {
				
				if ( TSCOOKIES.cookie.preferences ) {
					
					dataLayer.push({'event':'cookieconsent_preferences'});
					
				}
				
				if ( TSCOOKIES.cookie.statistics ) {

					dataLayer.push({'event':'cookieconsent_statistics'});
					
				}
				
				if ( TSCOOKIES.cookie.marketing ) {
					
					dataLayer.push({'event':'cookieconsent_marketing'});
					
				}

			}

		},

		hooks: {

			triggerOnLoad: function() {

				var event = new Event( 'tscookiesLoaded' );

				TSCOOKIES.hooks.triggerDocument( event );

			},

			triggerOnConsent: function() {

				var event = new Event( 'tscookiesSetConsent' );

				TSCOOKIES.hooks.triggerDocument( event );

			},

			triggerDocument: function( event ) {

				document.dispatchEvent( event );

			}

		},

		sources: {

			init: function() {

				//audio
				//video
				//iframe
				//embed
				//img
				//script
				//source
				//track

				// NOTE: only fire this function on first load, after that, use afterConsent();
				
				if ( tsCookiesConsent.placeholder !== null && tsCookiesConsent.placeholder.indexOf( 'true' ) === 0 ) {
					
					$.get( TSCOOKIES.pluginURL + 'templates/placeholder.mst', function ( data ) {

						templateHtml = data;
						
						$( '[data-src]' ).each( function( i ) {

							$element = $( this );

							var consent = $element.data( 'consent' );

							var newElement = Mustache.render( templateHtml, {

								placeholder_original : $element.outerHTML(),
								placeholder_cookies : consent
			
							});

							$element.after( newElement );
							$element.remove();

							TSCOOKIES.sources.afterConsent();

						});

					});

				} else {

					TSCOOKIES.sources.afterConsent();
				
				}

			},

			afterConsent: function() {

				$( '[data-src]' ).each( function( i ) {

					$element = $( this );
					
					var consent = $element.data( 'consent' );
					var src = $element.data( 'src' );

					TSCOOKIES.sources.load( $element, consent, src );

				});

			},

			load: function( $element, consent, src ) {

				var loadElement = true;

				consent = consent.split( ',' );

				if ( consent.indexOf( 'necessary' ) >= 0 && TSCOOKIE.cookie.necessary === false ) {
					
					loadElement = false;

				}

				if ( consent.indexOf( 'preferences' ) >= 0 && TSCOOKIE.cookie.preferences === false ) {
					
					loadElement = false;

				}

				if ( consent.indexOf( 'statistics' ) >= 0 && TSCOOKIE.cookie.statistics === false ) {
					
					loadElement = false;

				}

				if ( consent.indexOf( 'marketing' ) >= 0 && TSCOOKIE.cookie.marketing === false ) {
					
					loadElement = false;

				}
				
				if ( loadElement ) {

					$element.attr( 'src', src );

					if ( tsCookiesConsent.placeholder.indexOf( 'true' ) === 0 ) {
						
						$element.parent().find( '.placeholderCover' ).hide();

					}

				} else {

					var attr = $element.attr( 'src' );
					
					if ( typeof attr !== typeof undefined && attr !== false ) {

						$element.removeAttr( 'src' );

					}

					if ( tsCookiesConsent.placeholder.indexOf( 'true' ) === 0 ) {
						
						$element.parent().find( '.placeholderCover' ).show();

					}

				}
				
			}

		},

		analytics: {

			getCookiesArray: function() {

				var cookies = { };

				if ( document.cookie && document.cookie != '' ) {

					var split = document.cookie.split(';');
					
					for ( var i = 0; i < split.length; i++ ) {

						var name_value = split[i].split("=");
						
						name_value[0] = name_value[0].replace(/^ /, '');
						
						cookies[decodeURIComponent(name_value[0])] = decodeURIComponent(name_value[1]);
					}
					
				}

				return cookies;

			}

		}

	};

	var UTIL = {

		exec: function (controller, action) {

			var ns = TSCOOKIES;
			action = (action === undefined) ? 'init' : action;

			if (controller !== '' && ns[controller] && typeof ns[controller][action] === 'function') {

				ns[controller][action]();

			}

		},

		init: function () {

			UTIL.exec('init');

		}

	};
	
	//$.TSCOOKIES = TSCOOKIES; // Make global available

	$(window).ready(UTIL.init);

})(jQuery);